import type { GetBrandDTO } from "@nlc/shared-types";

import { useQuery } from "@tanstack/react-query";
import { TargetIcon } from "lucide-react";

import { useRoleAccess } from "@/features/auth/permissions/useRoleAccess";
import { CollapsibleBox } from "@/features/request/edit/components/CollapsibleBox";
import { getBrandById } from "@/hooks/queryKeys.ts";
import { useGetRequest } from "@/hooks/useGetRequest.tsx";
import apiClient from "@/lib/api/client.ts";

import { BrandDetailsTabs } from "./components/BrandDetailsTabs";

function useGetBrand(brandId: null | number | undefined) {
  return useQuery<GetBrandDTO>({
    enabled: !!brandId,
    queryFn: async () => await apiClient.url(`/brands/${brandId}`).get().json(),
    queryKey: getBrandById.getBrandById(brandId!),
  });
}

export function BrandSection() {
  const request = useGetRequest();
  const { data: brandData } = useGetBrand(request?.data?.brandId);

  const { canAccess } = useRoleAccess();
  const canView = canAccess("edit-request.brand-section");

  if (!brandData || !canView) return null;

  return (
    <CollapsibleBox
      icon={<TargetIcon className="text-white" size={16} />}
      iconClassName="bg-gray-500"
      title="Brand details"
    >
      <BrandDetailsTabs brand={brandData} />
    </CollapsibleBox>
  );
}
